import { render, staticRenderFns } from "./WebcamCaptureDialog.vue?vue&type=template&id=5394210f&scoped=true&lang=pug&"
import script from "./WebcamCaptureDialog.vue?vue&type=script&lang=js&"
export * from "./WebcamCaptureDialog.vue?vue&type=script&lang=js&"
import style0 from "./WebcamCaptureDialog.vue?vue&type=style&index=0&id=5394210f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394210f",
  null
  
)

/* custom blocks */
import block0 from "./WebcamCaptureDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports